module.exports = __webpack_public_path__ + "static/img/96002C_X_all_20170801_LC.c654b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/96002C_X_all_20170801_LC.png
// module id = cgVe
// module chunks = 0